<template>
  <div v-loading="isLoging">
    <el-dialog
      :title=title
      width="40%"
      top="2rem"
      :close-on-click-modal="false"
      :visible.sync="showDialog"
      :destroy-on-close="true"
      @close="close()"
    >
      <div style="margin-top: 1rem;margin-right: 100px;">
        <el-form ref="roleFormRef" :rules="rules" :model="form" label-width="140px" >
          <el-form-item label="角色key" prop="roleKey">
            <el-input v-model="form.roleKey" clearable></el-input>
          </el-form-item>
          <el-form-item label="角色名" prop="roleName">
            <el-input v-model="form.roleName" clearable></el-input>
          </el-form-item>
          <el-form-item label="角色权限等级" prop="authority">
            <el-input v-model="form.authority" clearable></el-input>
            <!--<el-select
              v-model="form.roleLevel"
              style="width: 100%"
              placeholder="请选择角色权限等级"
            >
              <el-option label="0" value="0"></el-option>
              <el-option label="1" value="1"></el-option>
              <el-option label="2" value="2"></el-option>
              <el-option label="3" value="3"></el-option>
            </el-select>-->
          </el-form-item>
          <el-form-item>
            <div style="float: right;">
              <el-button type="primary" @click="onSubmit" :loading="dialogLoading" >保存</el-button>
              <el-button @click="close">取消</el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from '@/api/http.js'
import config from '@/utils/config.js'
import MediaServer from './../service/MediaServer'

export default {
  name: "roleEdit",
  props: {},
  computed: {},
  created() {},
  data() {
    return {
      title: '添加角色',
      listChangeCallback: null,
      showDialog: false,
      isLoging: false,
      dialogLoading: false,
      platformList: [],
      mediaServer: new MediaServer(),
      form: {
        roleKey: '',
        roleName: '',
        authority: '',
      },

      rules: {
        roleKey: [{ required: true, message: "请输入角色key", trigger: "blur" }],
        roleName: [{ required: true, message: "请输入角色名称", trigger: "blur" }],
        authority: [{ required: true, message: "请输入角色权限等级", trigger: "blur" }]
      },
    };
  },
  methods: {
    openDialog: function (form, callback) {
      this.showDialog = true;
      this.listChangeCallback = callback;
      this.title = '添加角色'
      if (form != null) {
        this.form = {...form};
        this.title = '编辑角色'
      }
    },
    onSubmit: function () {
      this.dialogLoading = true;
      var that = this;
      this.$refs.roleFormRef.validate(flag => {
        //表单验证通过
        if (flag) {
          if (that.form.id) {
            const {createTime, updateTime, ...params} = {...this.form}
            this.$axios({ method: 'post', url:`/api/role/update`, params }).then( res => {
              if (res.data.code == 0) {
                that.$message.success('修改成功')
                that.showDialog = false;
                if (that.listChangeCallback != null) {
                  that.listChangeCallback();
                  that.dialogLoading = false;
                }
              } else {
                that.$message.error(res.data.msg)
              }
            }).catch(error => {
              this.dialogLoading = false;
            });
          } else {
            this.$axios({ method: 'post', url:`/api/role/add`, params: {...this.form} }).then( res => {
              if (res.data.code == 0) {
                that.$message.success('添加成功')
                that.showDialog = false;
                if (that.listChangeCallback != null) {
                  that.listChangeCallback();
                }
              } else {
                that.$message.error(res.data.msg)
              }
              that.dialogLoading = false;
            }).catch(error => {
              this.dialogLoading = false;
            });
          }
        } else {
          that.dialogLoading = false;
          return this.$message.error('请按照格式要求输入数据')
        }
      })
    },
    close() {
      this.form = {
        roleKey: '',
        roleName: '',
        authority: '',
      }
      // this.$refs.roleFormRef.resetFields();
      this.showDialog = false;
      this.dialogLoading = false;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/dialog/roleEdit.vue